import { SxProps } from '@mui/material';
import { FONT_ORACLE, TEXT_PRIMARY } from 'components/pages/insights/constants';

export const closeButtonSx: SxProps = {
  position: 'absolute',
  top: { xs: 16, lg: 24 },
  right: { xs: 16, lg: 24 },
  p: 0,
  minWidth: 'auto',
};

export const titleSx: SxProps = {
  fontFamily: FONT_ORACLE,
  fontSize: 24,
  fontWeight: 400,
  color: TEXT_PRIMARY,
  letterSpacing: '-0.96px',
  lineHeight: '28px',
  textAlign: 'center',
  maxWidth: { lg: 250 },
};

export const subtitleSx: SxProps = {
  fontFamily: FONT_ORACLE,
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: '-0.32px',
  lineHeight: '22px',
  textAlign: 'center',
  maxWidth: { xs: 172, lg: 230 },
  textWrap: { xs: 'balance', lg: 'initial' },
};

export const starContainerSx: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: 2,
};

export const primaryButtonSx: SxProps = {
  fontFamily: FONT_ORACLE,
  color: 'common.white',
  letterSpacing: 0,
  backgroundColor: 'common.black',
  width: 1,
  py: 4,
  textTransform: 'none',
  borderRadius: 25,
  fontSize: 16,
  fontWeight: 400,
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    backgroundColor: 'common.black',
    transform: 'translateY(-1px)',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
  },
  '&:disabled': {
    backgroundColor: '#CECECE',
    color: '#F4F4F4',
  },
  '@media (hover: none)': {
    '&:hover, &:focus, &:active': {
      bgcolor: '#181819',
      '-webkit-text-fill-color': 'common.white',
    },
  },
};
